export default {
  title: "Дизайн карты Wallet",
  emptyState: {
    pageUnavailable: "Страница пока недоступна",
    description:
      "Чтобы получить доступ к странице, необходимо приобрести тариф «Промо» или «Про+»",
    buttonText: "К тарифам",
  },
  tradingPoint: "Торговая точка",
  actions: {
    resetDesign: "Вернуть базовый дизайн",
    saveChanges: "Сохранить изменения",
  },
  walletCardPreview: {
    clientName: "Имя клиента",
    balance: "Баланс",
    discount: "Скидка",
  },
  walletCardSettings: {
    colors: {
      title: "Цвета карты Wallet",
      background: "Цвет фона",
      text: "Цвет текста",
    },
    logo: {
      title: "Логотип заведения",
      noLogo: "Нет логотипа",
      hasLogo: "Есть логотип",
      aspectRatio: "Соотношение сторон логотипа — 1:1",
      fileRequirements: "PNG, JPG, JPEG — 1 файл до 5 Мб",
    },
    stripe: {
      title: "Подложка",
      noStripe: "Нет подложки",
      image: "Изображение",
      colorFill: "Заливка цветом",
      aspectRatio: "Соотношение сторон — 3:1",
      fileRequirements: "PNG, JPG, JPEG — 1 файл до 5 Мб",
      color: "Цвет подложки",
    },
  },
};
